import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Icon } from "@mostlycode/ui"

const StyledStylishIcon = styled.span`
  position: relative;
`

const StyledBgIcon = styled(Icon)`
  position: relative;
  fill: ${(props) => props.theme.colors.ice};
  width: ${(props) => props.bgSize};
  height: ${(props) => props.bgSize};
  transform: rotateZ(90deg);
`

const StyledContentIcon = styled(Icon)`
  position: absolute;
  left: 1.5rem;
  top: 0.5rem;
  fill: ${(props) => props.theme.colors.kelp};
  width: ${(props) => props.iconSize};
  height: ${(props) => props.iconSize};
`

function StylishIcon({ bg, icon, size, ...props }) {
  return (
    <StyledStylishIcon {...props}>
      <StyledBgIcon bgSize={`${size}rem`} icon={bg} />
      <StyledContentIcon iconSize={`${size - 2}rem`} icon={icon} />
    </StyledStylishIcon>
  )
}

export default StylishIcon

StylishIcon.defaultProps = {
  size: 8,
}
StylishIcon.propTypes = {
  size: PropTypes.number,
}
